import nfetch from "@/utils/events/nfetch";

import UsuarioModel from "../models/usuarioModel";

import { iServiceCached } from "./base/iServiceCached";

class VendedorService extends iServiceCached<UsuarioModel> {
    constructor() {
        super("Usuario");
    }

    private async getUsuariosFranquia(franquiaId: number, refresh = false): Promise<UsuarioModel[]> {
        if (this.cached[franquiaId] && !refresh) {
            return this.cached[franquiaId];
        }

        const response = await nfetch(`/${this.controllerName}/GetUsuariosFranquia`, {
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<Promise<UsuarioModel[]>>();

        this.cached[franquiaId] = response;

        return response;
    }

    public async comboCached(franquiaId: number, refresh = false) {
        const retorno = await this.getUsuariosFranquia(franquiaId, refresh);
        return retorno.map(p => ({ value: p.id, text: p.nome, setorId: p.setorId }));
    }
}

export default new VendedorService();
